import { FONT_SIZES, FONT_WEIGHTS, TYPOGRAPHY_COLORS } from '../globalTheme';
import { SIZE, WEIGHTS, FONT_TYPES, TYPOGRAPHY_COLOR_TYPES } from '../globalTypes';

const DISPLAY_TEXT_SIZE: Record<SIZE, string> = {
	xs: '24px',
	sm: '30px',
	md: '36px',
	lg: '48px',
	xl: '60px',
	xxl: '72px'
};

const DISPLAY_LINE_HEIGHT: Record<SIZE, string> = {
	xs: '32px',
	sm: '38px',
	md: '44px',
	lg: '60px',
	xl: '72px',
	xxl: '90px'
};

const DISPLAY_LETTER_SPACING: Record<SIZE, string> = {
	xs: '0em',
	sm: '0em',
	md: '-0.02em',
	lg: '-0.02em',
	xl: '-0.02em',
	xxl: '-0.02em'
};

const TEXT_LINE_HEIGHT: Record<SIZE, string> = {
	xs: '18px',
	sm: '20px',
	md: '24px',
	lg: '28px',
	xl: '30px',
	xxl: '32px'
};

const HEADING_SIZE_MAP: Record<'h1' | 'h2' | 'h3', SIZE> = {
	h1: 'xxl',
	h2: 'xl',
	h3: 'lg'
};

function resolveTypographyConfig(
	size: SIZE,
	weight: WEIGHTS,
	type: FONT_TYPES
): { size: SIZE; weight: WEIGHTS; effectiveType: 'text' | 'display' } {
	const effectiveWeight = weight === 'normal' ? 'regular' : weight;
	if (type === 'h1' || type === 'h2' || type === 'h3') {
		return { size: HEADING_SIZE_MAP[type], weight: effectiveWeight, effectiveType: 'display' };
	}
	return {
		size,
		weight: effectiveWeight,
		effectiveType: type === 'display' ? 'display' : 'text'
	};
}

export function getTypographyStyles(
	size: SIZE,
	weight: WEIGHTS,
	type: FONT_TYPES,
	color: TYPOGRAPHY_COLOR_TYPES
) {
	const {
		size: resolvedSize,
		weight: resolvedWeight,
		effectiveType
	} = resolveTypographyConfig(size, weight, type);
	return {
		fontWeight: FONT_WEIGHTS[resolvedWeight],
		fontSize: effectiveType === 'text' ? FONT_SIZES[resolvedSize] : DISPLAY_TEXT_SIZE[resolvedSize],
		lineHeight:
			effectiveType === 'text' ? TEXT_LINE_HEIGHT[resolvedSize] : DISPLAY_LINE_HEIGHT[resolvedSize],
		letterSpacing: effectiveType === 'text' ? '0em' : DISPLAY_LETTER_SPACING[resolvedSize],
		color: TYPOGRAPHY_COLORS[color] || color
	};
}
